import React, { Fragment } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Image } from '../../../AbstractElements';
import { HoverEffect } from '../../../Constant';
import HeaderCard from '../../Common/HeaderCard';
import { imageList } from './ImagePath';

const Hover11 = () => {
  return (
    <Fragment>
      <Row>
        <Col sm='12'>
          <Card>
            <HeaderCard title={HoverEffect} hover={' 11'} />
            <CardBody>
              <div id='aniimated-thumbnials10' className='row gallery my-gallery'>
                {imageList.map((item, i) => {
                  return (
                    <figure itemProp='associatedMedia' key={i} className='col-md-3 col-6 img-hover hover-11'>
                      <div>
                        <Image className='img-fluid' src={require(`../../../assets/images/${item.src}`)} itemProp='thumbnail' alt='' />
                      </div>
                    </figure>
                  );
                })}
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default Hover11;
